// extracted by mini-css-extract-plugin
export var generatorBox = "GeneratorBox-module--generatorBox--cgQnk";
export var large = "GeneratorBox-module--large--3l9PR";